module.exports = __webpack_public_path__ + "static/media/img-2-en.d2474aa9.webp";